import { SET_PRODUCT, SET_PRODUCTS} from "../actions/types";

const initialState = {
  product: {},
  products: {}
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_PRODUCT:
      return {
        ...state,
        product: action.product
      };
    case SET_PRODUCTS:
      return {
        ...state,
        products: action.products
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/reducers/product.js